import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroupDirective, Validators } from '@angular/forms';
import { ValidatingEnroleeMessage } from 'src/app/utility/services/message/custom-messages';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { IndividualClaimSubmissionService } from '../../service/individual-claim-submission/individual-claim-submission.service';
import { AppContentMessage } from '../../model/appContentMessage';
import { PersonNameValidator } from 'src/app/utility/validator/person-name.validator';
import { PhoneValidator } from 'src/app/utility/validator/phone.validator';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-validate-claim-ind',
  templateUrl: './validate-claim-ind.component.html',
  styleUrls: ['./validate-claim-ind.component.scss']
})
export class ValidateClaimIndComponent implements OnInit {

  birthYearRegularExpression = "^[0-9]{1,4}";
  message: any;
  claimEntryId: number;
  browserId: string;
  securityToken: string;
  subscribeTimer: any;
  isOtpGenerate = false;
  otpFlag = false;
  otpLeftTime = 120;
  isMobileNumberReadonly: boolean = false;
  isDisabledNext: boolean = true;
  customMessage = new ValidatingEnroleeMessage();
  fromDirectiveOTP: FormGroupDirective;
  fromDirectiveValidateClaim: FormGroupDirective;
  recaptchaEnabled = environment.enableCaptcha;

  validateExistingClaimForm = this.fb.group({
    claimNumber: [null, [Validators.required]],
    birthYear: [null, [Validators.required, Validators.pattern(this.birthYearRegularExpression)]],
    claimSubmitterName: [null, [Validators.required, PersonNameValidator]],
    claimSubmitterMobileNumber: [null, [Validators.required, PhoneValidator]],
    recaptcha: [null,  this.recaptchaEnabled ? [Validators.required] : []],
  });

  otpForm = this.fb.group({
    otpNumber: [null, [Validators.required]]
  });

  @Input() set isParentTabSelectionChange(value) {
    if (value) {
      this.resetFromSettings();
      this.resetIsParentTabSelectionChangeValue.emit();
    }
  }
  @Output() resetIsParentTabSelectionChangeValue = new EventEmitter<any>();
  @Output() onValidClaim = new EventEmitter<any>();

  constructor(
    private fb: FormBuilder,
    private validateClaimService: IndividualClaimSubmissionService,
    private messageService: MessageService,
  ) { }

  ngOnInit() {
    this.otpLeftTime = this.customMessage.otpLeftTime;
  }

  genarateOTP() {
    this.otpFlag = false;
    const entity = this.validateExistingClaimForm.value;

    this.validateClaimService
      .validateIndividualClaim(entity)
      .subscribe(
        res => {
          if (res.status != AppContentMessage.RESPONSE_STATUS_SUCCESS) {
            this.messageService.show(res.msg, "error");
            return;
          }

          this.claimEntryId = res.data.claimEntryId;
          this.browserId = res.data.browserId;
          this.securityToken = res.data.requestToken;
          this.otpFlag = true;
          this.isOtpGenerate = !this.isOtpGenerate;
          sessionStorage.setItem('requestToken', res.data.requestToken);
          this.startTimerForOTP();

        },
        error => {
          this.validateExistingClaimForm.patchValue({ recaptcha: null });
          this.messageService.show(error.error.message, "error");
          if(this.recaptchaEnabled){grecaptcha.reset();}
        }
      );
  }

  startTimerForOTP() {
    this.subscribeTimer = setInterval(() => {
      this.otpLeftTime--;
      if (this.otpLeftTime == 0) {
        this.clearTimer();
        this.otpFlag = false;
        this.otpLeftTime = this.customMessage.otpLeftTime;
        this.isOtpGenerate = false;
        this.messageService.show(this.customMessage.otpTimeExpire, "error");
        this.otpForm.reset();
        this.validateExistingClaimForm.patchValue({ recaptcha: null });
        if(this.recaptchaEnabled){grecaptcha.reset();}
      }
    }, 1000);
  }

  verifyOTP(
    formDirective1: FormGroupDirective,
    formDirective2: FormGroupDirective
  ) {
    this.fromDirectiveOTP = formDirective2;
    this.fromDirectiveValidateClaim = formDirective1;

    this.validateClaimService
      .otpValidationIndividual(this.otpForm.value.otpNumber, this.validateExistingClaimForm.value.claimSubmitterMobileNumber)
      .subscribe(
        res => {
          this.clearTimer();
          this.notifyParentComponent();
          this.resetFromSettings();
          this.isDisabledNext = false;
        },
        error => {
          if (AppContentMessage.OTP_VALIDATION_Try_Limit_Exceeded == error.error.message) {
            this.clearTimer();
            this.resetFromSettings();
          }
          this.messageService.show(error.error.message, "error");
        }
      );
  }
  clearTimer() {
    this.otpLeftTime = this.customMessage.otpLeftTime;
    clearInterval(this.subscribeTimer);
  }

  resetFromSettings() {
    if (this.fromDirectiveValidateClaim != null) {
      this.fromDirectiveValidateClaim.resetForm();
    }
    if (this.fromDirectiveOTP != null) {
      this.fromDirectiveOTP.resetForm();
    }
    this.validateExistingClaimForm.reset();
    this.otpForm.reset();
    this.otpFlag = false;
    this.otpLeftTime = this.customMessage.otpLeftTime;
    this.isOtpGenerate = false;
    //grecaptcha.reset();
  }

  notifyParentComponent() {
    const data = {
      claimEntryId: this.claimEntryId,
      browserId: this.browserId,
      securityToken: this.securityToken,
    }
    this.onValidClaim.emit(data);
  }

  resolved = (captchaKey: string) => {
    this.validateExistingClaimForm.patchValue({ recaptcha: captchaKey });
  }

  mobileNumberChanged() {
    this.resetIsParentTabSelectionChangeValue.emit();
    this.isDisabledNext = true;
  }

}
